import { render } from "./PatientVideoCall.vue?vue&type=template&id=7dd2f53e"
import script from "./PatientVideoCall.vue?vue&type=script&lang=js"
export * from "./PatientVideoCall.vue?vue&type=script&lang=js"

import "./PatientVideoCall.vue?vue&type=style&index=0&id=7dd2f53e&lang=scss"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__